import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AnalyticsPage } from '@/pages/admin/analytics/AnalyticsPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/admin/analytics/')({
  component: AnalyticsPage,
  validateSearch: dataTableSearchSchema({
    tenantId: z.string().optional()
  })
});
